import React, { useState } from 'react';
import VideoModal from './VideoModal';
import { intervalLogging, stopLogging } from "../common/Logger";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";

export default function HitCourseModal(props){
    const [cookies] = useCookies(['hiball_token']);
    const location = useLocation();

    const [modalState, setModalState] = useState(false);

    const openModal = (event) => {
        let gameRecordId = event.currentTarget.id;
        let locationSplit = location['pathname'].split('/');
        let playerType = locationSplit[1];
        let playerId = locationSplit[2];

        let playerObj = {
            playerType,
            playerId,
            gameRecordId
        }

        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        setModalState(true);
    }

    const closeModal = () => {
        let locationSplit = location['pathname'].split('/');
        let playerType = locationSplit[1];
        let playerId = locationSplit[2];

        let playerObj = {
            playerType,
            playerId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        setModalState(false);
    }

    return (
        <>
            {
            props.gameRecordId
            ?
            <>
            <circle 
                onClick={openModal}
                key={"circle_"+props.gameRecordId}
                id={props.gameRecordId}
                cx={props.cx}
                cy={props.cy}
                r="5" 
                fill={props.color}
                opacity="1" 
                stroke="black"
                style={{cursor:'pointer'}}
            ></circle>
            <VideoModal content={"hitCourse"} modalState={modalState} closeModal={closeModal} parameterSet={{"gameRecordIds":[props.gameRecordId]}} />
            </>
            :
            <>
            <circle 
                key={"circle_"+props.gameRecordId}
                id={props.gameRecordId}
                cx={props.cx}
                cy={props.cy}
                r="5" 
                fill={props.color}
                opacity="1" 
                stroke="black"
            ></circle>
            </>
            }
        </>
    )
}